import {Injectable, OnInit} from '@angular/core';
import {OverlayContainer} from "@angular/cdk/overlay";
import {DatePipe} from "@angular/common";


@Injectable()


// Used for the communication between auth layout and admin layout
export class AdminLayoutService implements OnInit{
    theme: string = 'alt-dark-theme';
    systemDate = new Date();
    notifications: any[] = [];
    icon = null;
    businessName = null;

    constructor(private overlayContainer: OverlayContainer, private datePipe: DatePipe) {

    }

    ngOnInit() {
        this.getIcon();
        this.getName();
    }

    systemDateCheck(){
        if(this.datePipe.transform(this.getSystemDate(), 'dd/mm/yyyy') !== this.datePipe.transform(new Date(), 'dd/mm/yyy')){
            let wrongDate:any = {};
            wrongDate.route = '/movement/date';
            wrongDate.message = 'A data do sistema esta retrasada';
            if(this.notifications.indexOf(wrongDate) >= 1){
            }else{
                this.notifications.push(wrongDate);
            }
        }else {
            let wrongDate: any = {};
            wrongDate.route = '/movement/date';
            wrongDate.message = 'A data do sistema esta retrasada';
            this.notifications.splice(this.notifications.indexOf(wrongDate), 1)
        }
    }


    setTheme(theme) {
        this.overlayContainer.getContainerElement().classList.remove('dark-theme', theme);
        this.theme = theme;
        this.overlayContainer.getContainerElement().classList.add(theme);
        sessionStorage.setItem('theme', theme);

    }

    getSystemDate(){
        return localStorage.getItem('systemDate')
    }

    setBusinessIcon(path) {
        this.icon = path;
        localStorage.setItem('icon', path)
    }


    setBusinessName(name) {
        this.businessName = name;
        localStorage.setItem('businessName', name)
    }

    getIcon(){

        if (localStorage.getItem('icon') !== null){
            return this.icon = localStorage.getItem('icon');
        }else {
            return null
        }
    }

    getName() {
        if (localStorage.getItem('businessName') !== null){
           return this.businessName = localStorage.getItem('businessName');
        }else {
            return null
        }
    }



    getTheme(){
        return sessionStorage.getItem('theme');
    }

    setDate(date){
        this.systemDate = date;
        // TODO remove from localstorage and figure out how to set the system date
        localStorage.setItem('systemDate', date);
            this.systemDateCheck();
    }


    getNotifications(){
        //this.systemDateCheck();
        // return this.notifications;
        return [];
    }

}


// WEBPACK FOOTER //
// ./src/app/layouts/admin/admin-layout.service.ts